export default __webpack_public_path__ + "static/media/DRE.bef202c6.png";